export const PARTNER_DASHBOARD_UNLOCK_CLASS_LEVEL_CAMPAIGNS = 'PARTNER_DASHBOARD_UNLOCK_CLASS_LEVEL_CAMPAIGNS';
export const PARTNER_DASHBOARD_TRIAL_PROGRAM_MODE_EDIT = 'PARTNER_DASHBOARD_TRIAL_PROGRAM_MODE_EDIT';
export const PARTNER_DASHBOARD_SERVICE_PRICING_PROOF = 'PARTNER_DASHBOARD_SERVICE_PRICING_PROOF';
export const PARTNER_MARKETING_OPT_IN = 'PARTNER_MARKETING_OPT_IN';

export const OPTIMIZELY_FEATURE_FLAGS_KEYS = {
  [PARTNER_DASHBOARD_UNLOCK_CLASS_LEVEL_CAMPAIGNS]: 'partner_dashboard_-_unlock_class-level_campaigns',
  [PARTNER_DASHBOARD_TRIAL_PROGRAM_MODE_EDIT]: 'partner_dashboard_trial_program_mode_edit',
  [PARTNER_DASHBOARD_SERVICE_PRICING_PROOF]: 'partner_dashboard_service_pricing_proof',
  [PARTNER_MARKETING_OPT_IN]: 'partner_marketing_opt_in',
};
